var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"msp-valutazione-allenamento-mobile"},[_c('msp-valutazione',{attrs:{"readonly":_vm.readonly,"init-value":_vm.initValue},on:{"update":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }